import { render, staticRenderFns } from "./PreviewGeneratedInvoice.vue?vue&type=template&id=afa179e6&scoped=true"
import script from "./PreviewGeneratedInvoice.vue?vue&type=script&lang=js"
export * from "./PreviewGeneratedInvoice.vue?vue&type=script&lang=js"
import style0 from "./PreviewGeneratedInvoice.vue?vue&type=style&index=0&id=afa179e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa179e6",
  null
  
)

export default component.exports